module.exports = __webpack_public_path__ + "static/media/logo.311dc9fd.svg";